var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "warning",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_639_77",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_639_77)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.3335 28.0001L16.0002 2.66675L30.6668 28.0001H1.3335ZM16.0002 24.0001C16.3779 24.0001 16.6946 23.8723 16.9502 23.6167C17.2057 23.3612 17.3335 23.0445 17.3335 22.6667C17.3335 22.289 17.2057 21.9723 16.9502 21.7167C16.6946 21.4612 16.3779 21.3334 16.0002 21.3334C15.6224 21.3334 15.3057 21.4612 15.0502 21.7167C14.7946 21.9723 14.6668 22.289 14.6668 22.6667C14.6668 23.0445 14.7946 23.3612 15.0502 23.6167C15.3057 23.8723 15.6224 24.0001 16.0002 24.0001ZM14.6668 20.0001H17.3335V13.3334H14.6668V20.0001Z",
    fill: "#EE7B00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.ef498f18f2e5123fb2252a49b7d948f6.svg";
export { ForwardRef as ReactComponent };